/**
 * Enum representing the type of batch operation
 */
export enum BatchOperationEnum {
  All = 'All',
  Classification = 'Classification',
  FolderExpansion = 'FolderExpansion',
  Delete = 'Delete',
}
